import React from 'react';

import { Typography } from '@mui/material';

import { numberWithCommas } from '@clearverify/utils';

import { OverviewManualRequestsActivity } from 'src/types/dashboard';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockManualRequestActivityProps = {
  manualRequestsActivity: OverviewManualRequestsActivity;
  loading: boolean;
};

export const DashboardOverviewBlockManualRequestActivity: React.FC<
  DashboardOverviewBlockManualRequestActivityProps
> = ({ manualRequestsActivity, loading }) => {
  const total =
    manualRequestsActivity.approved +
    manualRequestsActivity.declined +
    manualRequestsActivity.pending;

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(total)}
      title="Activity rate of manual requests"
      subtitle={
        <React.Fragment>
          <Typography
            component="span"
            variant="body2"
            color="success.main"
          >{`${manualRequestsActivity.approved} Approved`}</Typography>
          &nbsp;/&nbsp;
          {manualRequestsActivity.declined} Declined / {manualRequestsActivity.pending} Pending
        </React.Fragment>
      }
    />
  );
};
